/* eslint-disable camelcase */
const label = 'irure ea nulla anim officia';
const labelJp = 'elit dolor aliqua cupidatat aliqua';
export const forms = {
	page: 1,
	page_size: 5,
	total_items: 54,
	total_pages: 11,
	items: [
		{
			formName: {
				en_US: 'Form with associated templates',
				es_ES: 'Form with associated templates',
				fr_FR: 'Form with associated templates',
				ja_JP: 'Form with associated templates',
			},
			formId: 61,
			updatedDate: '2021-07-08T02:01:35.852Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'minim eiusmod irure id amet',
				es_ES: 'ut dolore cupidatat ullamco laboris',
				fr_FR: 'mollit anim duis consectetur nisi',
				ja_JP: 'labore labore incididunt culpa labore',
			},
			formId: 35,
			updatedDate: '2021-04-26T11:51:21.457Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'minim irure fugiat velit enim',
				es_ES: 'velit et velit enim esse',
				fr_FR: 'irure sint et ipsum minim',
				ja_JP: 'ut cillum do occaecat irure',
			},
			formId: 50,
			updatedDate: '2021-07-02T18:19:45.462Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'consequat velit nulla minim occaecat',
				es_ES: 'amet occaecat ipsum exercitation esse',
				fr_FR: 'occaecat voluptate ullamco irure do',
				ja_JP: 'voluptate anim in elit sit',
			},
			formId: 81,
			updatedDate: '2021-07-23T01:25:24.015Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'nulla tempor do occaecat dolor',
				es_ES: 'labore laboris minim exercitation eiusmod',
				fr_FR: 'consectetur amet minim incididunt eiusmod',
				ja_JP: 'ea laboris aliquip nisi non',
			},
			formId: 95,
			updatedDate: '2021-10-21T23:33:05.150Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ea Lorem esse veniam sint',
				es_ES: 'cupidatat nostrud do exercitation incididunt',
				fr_FR: 'nostrud anim sit anim voluptate',
				ja_JP: 'officia et quis exercitation enim',
			},
			formId: 75,
			updatedDate: '2021-05-11T00:13:09.215Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'sunt veniam nisi veniam sit',
				es_ES: 'consectetur veniam est voluptate ex',
				fr_FR: 'laboris proident consequat labore dolor',
				ja_JP: 'amet reprehenderit et aliquip eu',
			},
			formId: 46,
			updatedDate: '2021-02-02T00:04:17.335Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'sint exercitation esse reprehenderit est',
				es_ES: 'reprehenderit commodo reprehenderit in proident',
				fr_FR: 'in anim labore adipisicing laboris',
				ja_JP: 'fugiat ipsum officia laborum ut',
			},
			formId: 99,
			updatedDate: '2021-08-18T14:22:50.277Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'do eiusmod incididunt duis est',
				es_ES: 'consectetur aliquip anim proident sunt',
				fr_FR: 'sit excepteur est aute nulla',
				ja_JP: 'incididunt ullamco adipisicing cupidatat Lorem',
			},
			formId: 16,
			updatedDate: '2022-01-01T02:23:53.205Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'veniam anim do pariatur est',
				es_ES: 'enim ex duis eiusmod enim',
				fr_FR: 'ullamco nostrud occaecat consectetur pariatur',
				ja_JP: 'sint consequat enim incididunt Lorem',
			},
			formId: 47,
			updatedDate: '2021-11-24T06:37:46.586Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ea et labore ea pariatur',
				es_ES: 'sint excepteur labore ea ad',
				fr_FR: 'ipsum do tempor dolore elit',
				ja_JP: 'consectetur eu deserunt ut ea',
			},
			formId: 42,
			updatedDate: '2021-11-26T05:31:13.055Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'dolor esse id consectetur et',
				es_ES: 'proident excepteur consectetur laborum aute',
				fr_FR: 'sit sunt dolor ullamco in',
				ja_JP: 'cillum occaecat culpa Lorem do',
			},
			formId: 60,
			updatedDate: '2021-11-27T06:19:40.053Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'incididunt ea qui sit officia',
				es_ES: 'aliquip tempor dolore occaecat velit',
				fr_FR: 'elit aliquip cupidatat aliqua amet',
				ja_JP: 'deserunt esse consectetur pariatur sint',
			},
			formId: 93,
			updatedDate: '2021-09-03T14:10:25.800Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'anim excepteur et est minim',
				es_ES: 'dolore excepteur deserunt duis aliquip',
				fr_FR: 'fugiat excepteur consequat ullamco qui',
				ja_JP: 'magna non aliquip cillum consequat',
			},
			formId: 5,
			updatedDate: '2021-05-13T13:29:55.774Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'commodo duis cupidatat veniam in',
				es_ES: 'incididunt sunt anim amet voluptate',
				fr_FR: 'dolore aute cillum anim tempor',
				ja_JP: 'aliquip nostrud anim excepteur adipisicing',
			},
			formId: 84,
			updatedDate: '2021-02-02T20:23:29.944Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ex ea nulla exercitation magna',
				es_ES: 'magna occaecat eu id magna',
				fr_FR: 'excepteur aliqua amet cupidatat proident',
				ja_JP: 'fugiat cillum nostrud nostrud proident',
			},
			formId: 45,
			updatedDate: '2021-06-01T07:41:59.382Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'occaecat sunt ea adipisicing do',
				es_ES: 'fugiat velit nisi id do',
				fr_FR: 'qui esse officia nostrud esse',
				ja_JP: 'nisi officia magna magna fugiat',
			},
			formId: 32,
			updatedDate: '2021-08-22T06:29:51.668Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ad ullamco proident mollit et',
				es_ES: 'mollit deserunt labore occaecat ex',
				fr_FR: 'occaecat amet est amet et',
				ja_JP: 'non pariatur sit nulla ea',
			},
			formId: 25,
			updatedDate: '2021-02-22T02:09:34.711Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'proident occaecat nostrud aliquip quis',
				es_ES: 'Lorem tempor reprehenderit ipsum velit',
				fr_FR: 'aliquip eiusmod in occaecat aute',
				ja_JP: 'excepteur officia aute ullamco do',
			},
			formId: 3,
			updatedDate: '2021-09-16T00:32:32.614Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'consectetur cupidatat consectetur sunt id',
				es_ES: 'pariatur duis nulla do nulla',
				fr_FR: 'cupidatat officia incididunt amet est',
				ja_JP: 'Lorem reprehenderit minim ut laborum',
			},
			formId: 9,
			updatedDate: '2021-05-30T21:54:28.721Z',
			defaultLanguage: 'en_US',
		},
	],
};

export const formsWithArchived = {
	page: 1,
	page_size: 5,
	total_items: 54,
	total_pages: 11,
	items: [
		{
			formName: {
				en_US: 'Form with associated templates',
				es_ES: 'Form with associated templates',
				fr_FR: 'Form with associated templates',
				ja_JP: 'Form with associated templates',
			},
			formId: 61,
			updatedDate: '2021-07-08T02:01:35.852Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'mock archived form en_US',
				es_ES: 'mock archived form es_ES',
				fr_FR: 'mock archived form fr_FR',
				ja_JP: 'mock archived form ja_JP',
			},
			formId: 100,
			updatedDate: '2021-04-26T11:51:21.457Z',
			defaultLanguage: 'en_US',
			attributes: {
				FORM_STATUS: 'archived',
			},
		},
		{
			formName: {
				en_US: 'minim irure fugiat velit enim',
				es_ES: 'velit et velit enim esse',
				fr_FR: 'irure sint et ipsum minim',
				ja_JP: 'ut cillum do occaecat irure',
			},
			formId: 50,
			updatedDate: '2021-07-02T18:19:45.462Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'consequat velit nulla minim occaecat',
				es_ES: 'amet occaecat ipsum exercitation esse',
				fr_FR: 'occaecat voluptate ullamco irure do',
				ja_JP: 'voluptate anim in elit sit',
			},
			formId: 81,
			updatedDate: '2021-07-23T01:25:24.015Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'nulla tempor do occaecat dolor',
				es_ES: 'labore laboris minim exercitation eiusmod',
				fr_FR: 'consectetur amet minim incididunt eiusmod',
				ja_JP: 'ea laboris aliquip nisi non',
			},
			formId: 95,
			updatedDate: '2021-10-21T23:33:05.150Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ea Lorem esse veniam sint',
				es_ES: 'cupidatat nostrud do exercitation incididunt',
				fr_FR: 'nostrud anim sit anim voluptate',
				ja_JP: 'officia et quis exercitation enim',
			},
			formId: 75,
			updatedDate: '2021-05-11T00:13:09.215Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'sunt veniam nisi veniam sit',
				es_ES: 'consectetur veniam est voluptate ex',
				fr_FR: 'laboris proident consequat labore dolor',
				ja_JP: 'amet reprehenderit et aliquip eu',
			},
			formId: 46,
			updatedDate: '2021-02-02T00:04:17.335Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'sint exercitation esse reprehenderit est',
				es_ES: 'reprehenderit commodo reprehenderit in proident',
				fr_FR: 'in anim labore adipisicing laboris',
				ja_JP: 'fugiat ipsum officia laborum ut',
			},
			formId: 99,
			updatedDate: '2021-08-18T14:22:50.277Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'mock archived form 2 en_US',
				es_ES: 'mock archived form 2 es_ES',
				fr_FR: 'mock archived form 2 fr_FR',
				ja_JP: 'mock archived form 2 ja_JP',
			},
			formId: 101,
			updatedDate: '2021-04-26T11:51:21.457Z',
			defaultLanguage: 'en_US',
			attributes: {
				FORM_STATUS: 'archived',
			},
		},
		{
			formName: {
				en_US: 'mock archived form 3 en_US',
				es_ES: 'mock archived form 3 es_ES',
				fr_FR: 'mock archived form 3 fr_FR',
				ja_JP: 'mock archived form 3 ja_JP',
			},
			formId: 102,
			updatedDate: '2021-04-26T11:51:21.457Z',
			defaultLanguage: 'en_US',
			attributes: {
				FORM_STATUS: 'archived',
			},
		},
		{
			formName: {
				en_US: 'do eiusmod incididunt duis est',
				es_ES: 'consectetur aliquip anim proident sunt',
				fr_FR: 'sit excepteur est aute nulla',
				ja_JP: 'incididunt ullamco adipisicing cupidatat Lorem',
			},
			formId: 16,
			updatedDate: '2022-01-01T02:23:53.205Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'veniam anim do pariatur est',
				es_ES: 'enim ex duis eiusmod enim',
				fr_FR: 'ullamco nostrud occaecat consectetur pariatur',
				ja_JP: 'sint consequat enim incididunt Lorem',
			},
			formId: 47,
			updatedDate: '2021-11-24T06:37:46.586Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ea et labore ea pariatur',
				es_ES: 'sint excepteur labore ea ad',
				fr_FR: 'ipsum do tempor dolore elit',
				ja_JP: 'consectetur eu deserunt ut ea',
			},
			formId: 42,
			updatedDate: '2021-11-26T05:31:13.055Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'dolor esse id consectetur et',
				es_ES: 'proident excepteur consectetur laborum aute',
				fr_FR: 'sit sunt dolor ullamco in',
				ja_JP: 'cillum occaecat culpa Lorem do',
			},
			formId: 60,
			updatedDate: '2021-11-27T06:19:40.053Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'incididunt ea qui sit officia',
				es_ES: 'aliquip tempor dolore occaecat velit',
				fr_FR: 'elit aliquip cupidatat aliqua amet',
				ja_JP: 'deserunt esse consectetur pariatur sint',
			},
			formId: 93,
			updatedDate: '2021-09-03T14:10:25.800Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'anim excepteur et est minim',
				es_ES: 'dolore excepteur deserunt duis aliquip',
				fr_FR: 'fugiat excepteur consequat ullamco qui',
				ja_JP: 'magna non aliquip cillum consequat',
			},
			formId: 5,
			updatedDate: '2021-05-13T13:29:55.774Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'commodo duis cupidatat veniam in',
				es_ES: 'incididunt sunt anim amet voluptate',
				fr_FR: 'dolore aute cillum anim tempor',
				ja_JP: 'aliquip nostrud anim excepteur adipisicing',
			},
			formId: 84,
			updatedDate: '2021-02-02T20:23:29.944Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'ex ea nulla exercitation magna',
				es_ES: 'magna occaecat eu id magna',
				fr_FR: 'excepteur aliqua amet cupidatat proident',
				ja_JP: 'fugiat cillum nostrud nostrud proident',
			},
			formId: 45,
			updatedDate: '2021-06-01T07:41:59.382Z',
			defaultLanguage: 'en_US',
		},
		{
			formName: {
				en_US: 'occaecat sunt ea adipisicing do',
				es_ES: 'fugiat velit nisi id do',
				fr_FR: 'qui esse officia nostrud esse',
				ja_JP: 'nisi officia magna magna fugiat',
			},
			formId: 32,
			updatedDate: '2021-08-22T06:29:51.668Z',
			defaultLanguage: 'en_US',
		},
	],
};

export const questions = {
	page: 1,
	total_items: 140,
	items: [
		{
			key: '5b81e64a-8276-4842-bb27-162fd0285d10',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'minim commodo',
				label: {
					en_US: 'occaecat occaecat exercitation nostrud adipisicing',
					es_ES: 'deserunt incididunt velit ad velit',
					fr_FR: 'minim irure cupidatat est dolore',
					ja_JP: 'commodo mollit dolore esse minim',
				},
				choice: 'dropdown',
				choices: {
					en_US: [
						'id id in velit nisi',
						'tempor pariatur sint mollit sint',
						'qui do culpa mollit ullamco',
						'mollit sunt incididunt elit adipisicing',
					],
					es_ES: [
						'tempor aliqua eiusmod magna tempor',
						'Lorem quis aliqua amet cillum',
						'occaecat exercitation exercitation veniam Lorem',
						'nisi aute eiusmod sint occaecat',
					],
					fr_FR: [
						'proident cillum excepteur irure aliqua',
						'anim laboris non veniam id',
						'cupidatat pariatur excepteur amet qui',
						'cupidatat cillum non ut dolor',
					],
					ja_JP: [
						'sunt elit deserunt quis cillum',
						'est elit voluptate id fugiat',
						'aliquip laboris consequat proident proident',
						'ipsum in magna adipisicing dolore',
					],
				},
			},
		},
		{
			key: '572b0808-f840-40ca-af51-d79a1631593d',
			fieldType: 'paragraph',
			content: {
				archived: false,
				fieldName: 'ullamco aliqua',
				label: {
					en_US: '**anim** anim sunt eu ea lala',
					es_ES: '**do** eu dolore minim minim',
					fr_FR: '**sint** fugiat tempor esse elit',
					ja_JP: '**consectetur** non enim non Lorem',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'f4e17259-6cbc-4976-ac8b-2fcd556347be',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'minim deserunt',
				label: {
					en_US: label,
					es_ES: 'reprehenderit voluptate mollit aute veniam',
					fr_FR: 'ad amet fugiat deserunt laboris',
					ja_JP: 'pariatur incididunt duis culpa irure',
				},
				choice: 'checkbox',
				choices: {
					en_US: [
						'do ut culpa voluptate proident',
						'nulla irure veniam excepteur officia',
						'adipisicing occaecat veniam elit veniam',
						'dolore labore irure irure ad',
					],
					es_ES: [
						'adipisicing fugiat voluptate sit quis',
						'enim do veniam nostrud ipsum',
						'reprehenderit dolore esse laboris ipsum',
						'commodo voluptate ea ipsum dolor',
					],
					fr_FR: [
						'velit officia magna amet veniam',
						'eu veniam consequat excepteur excepteur',
						'adipisicing commodo fugiat mollit in',
						'est est qui tempor adipisicing',
					],
					ja_JP: [
						labelJp,
						'anim incididunt ad quis eu',
						'ullamco consequat pariatur minim magna',
						'voluptate non aliqua qui mollit',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '170960e2-695e-4005-928c-c0cb530eb681',
			fieldType: 'textarea',
			content: {
				archived: false,
				fieldName: 'laboris sit',
				label: {
					en_US: 'adipisicing deserunt ex irure duis',
					es_ES: 'pariatur in incididunt nulla enim',
					fr_FR: 'exercitation est ea quis veniam',
					ja_JP: 'deserunt sint adipisicing consequat pariatur',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'b4dead93-4d34-4823-820a-c0770801e248',
			fieldType: 'textinput',
			content: {
				archived: false,
				fieldName: 'cupidatat non',
				label: {
					en_US: 'proident eu ad occaecat sint',
					es_ES: 'aliqua esse exercitation eu ea',
					fr_FR: 'Lorem dolore id ea do',
					ja_JP: 'ad Lorem adipisicing consectetur nisi',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '4c9d1e37-1bd8-49ed-b3e9-245ba9f4e839',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'ad elit',
				label: {
					en_US: 'irure eiusmod officia laboris et',
					es_ES: 'sit ut in velit nulla',
					fr_FR: 'velit non do esse duis',
					ja_JP: 'sint dolore id non commodo',
				},
				choice: 'radio',
				choices: {
					en_US: [
						'nostrud ipsum fugiat incididunt minim',
						'est reprehenderit dolor culpa consectetur',
						'irure incididunt laborum excepteur deserunt',
						'veniam minim non ullamco culpa',
					],
					es_ES: [
						'adipisicing est est aliqua mollit',
						'cillum sint nostrud duis Lorem',
						'adipisicing nulla id id nisi',
						'excepteur dolor ullamco sit commodo',
					],
					fr_FR: [
						'cillum sunt cillum duis sit',
						'ea non ea labore nisi',
						'minim sint fugiat sit consequat',
						'non voluptate eiusmod dolor tempor',
					],
					ja_JP: [
						'culpa cupidatat minim cillum commodo',
						'Lorem tempor nisi ad qui',
						'minim aute deserunt dolor ex',
						'dolore velit cupidatat sint anim',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'dedeb7c3-d347-4d6e-9f12-94a46a258b5b',
			fieldType: 'paragraph',
			content: {
				archived: false,
				fieldName: 'aute labore',
				label: {
					en_US: 'sit aliquip ea do laboris',
					es_ES: 'occaecat cillum anim aliquip in',
					fr_FR: 'velit nulla magna quis nostrud',
					ja_JP: 'laborum dolor Lorem culpa culpa',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'fe45cd94-d9c4-4186-9295-6bef241c5eb0',
			fieldType: 'textarea',
			content: {
				archived: false,
				fieldName: 'quis mollit',
				label: {
					en_US: 'sint do esse laboris consequat',
					es_ES: 'mollit esse incididunt veniam nostrud',
					fr_FR: 'do dolor reprehenderit est Lorem',
					ja_JP: 'qui in irure in laborum',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '2b8587fb-3163-48e5-be19-d6980b9cbe4e',
			fieldType: 'textinput',
			content: {
				archived: false,
				fieldName: 'id adipisicing',
				label: {
					en_US: 'sint dolore qui ullamco nulla',
					es_ES: 'nisi deserunt do ipsum nulla',
					fr_FR: 'culpa in aliqua nostrud exercitation',
					ja_JP: 'cupidatat aliqua minim Lorem cupidatat',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '8cc665e6-d176-4ff6-b847-8cb2aab2455e',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'culpa ullamco',
				label: {
					en_US: 'sunt commodo cupidatat ad minim',
					es_ES: 'aute ex laborum ullamco enim',
					fr_FR: 'nisi aliquip ipsum enim consectetur',
					ja_JP: 'labore mollit exercitation minim cillum',
				},
				choice: 'checkbox',
				choices: {
					en_US: [
						'ex proident consequat consectetur Lorem',
						'nulla cupidatat occaecat proident anim',
						'esse eiusmod sunt non do',
						'cillum minim voluptate aliquip est',
					],
					es_ES: [
						'aliqua irure enim aliqua velit',
						'ipsum ipsum anim in sunt',
						'eu consequat et occaecat esse',
						'ullamco mollit ea cillum tempor',
					],
					fr_FR: [
						'deserunt voluptate dolor irure nostrud',
						'cupidatat veniam sint minim in',
						'et do commodo sit laborum',
						'excepteur in Lorem culpa ipsum',
					],
					ja_JP: [
						'cupidatat amet tempor nisi fugiat',
						'esse laboris eiusmod dolor ad',
						'aliqua pariatur Lorem dolor aliqua',
						'esse occaecat incididunt ipsum proident',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'd202ebca-cccf-448b-8a49-43f3472b8112',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'aute ex',
				label: {
					en_US: 'esse cillum ea aliqua pariatur',
					es_ES: 'in et velit amet nulla',
					fr_FR: 'anim fugiat aliquip cupidatat adipisicing',
					ja_JP: 'nulla minim proident anim consectetur',
				},
				choice: 'dropdown',
				choices: {
					en_US: [
						'ea minim veniam sit occaecat',
						'amet exercitation ullamco laboris nisi',
						'commodo ipsum ad aliquip aliquip',
						'enim culpa dolore velit aliqua',
					],
					es_ES: [
						'adipisicing eu sint irure laboris',
						'anim nostrud ullamco eu et',
						'elit enim dolor officia minim',
						'excepteur tempor magna elit adipisicing',
					],
					fr_FR: [
						'aliqua velit minim eiusmod elit',
						'nisi sunt id velit velit',
						'nisi non aliqua sit aute',
						'ad consectetur officia enim do',
					],
					ja_JP: [
						'sit elit in commodo veniam',
						'enim quis incididunt do laborum',
						'et mollit aliqua elit ipsum',
						'pariatur nostrud amet est sunt',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'fc3cbd42-2c37-40ed-ac22-d5e994ac55ec',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'magna nisi',
				label: {
					en_US: 'labore dolore culpa non nisi',
					es_ES: 'adipisicing consequat nisi officia et',
					fr_FR: 'sint do quis laboris pariatur',
					ja_JP: 'nisi eiusmod et ex do',
				},
				choice: 'radio',
				choices: {
					en_US: [
						'occaecat sint exercitation esse minim',
						'nulla reprehenderit tempor et est',
						'aliquip esse ea excepteur in',
						'non dolore irure proident do',
					],
					es_ES: [
						'dolore nisi duis mollit quis',
						'veniam exercitation officia cupidatat minim',
						'ipsum aliqua occaecat adipisicing ut',
						'do qui occaecat exercitation reprehenderit',
					],
					fr_FR: [
						'duis non nulla cupidatat quis',
						'proident amet et duis cillum',
						'voluptate sunt ullamco laboris nulla',
						'sit dolor enim deserunt est',
					],
					ja_JP: [
						'velit nisi consequat sunt ullamco',
						'amet anim consequat dolor nulla',
						'et minim minim adipisicing incididunt',
						'ea nisi officia eu laborum',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '578dca2a-4f0a-410f-8d40-78ee46b5d164',
			fieldType: 'paragraph',
			content: {
				archived: false,
				fieldName: 'ipsum nisi',
				label: {
					en_US: 'fugiat in dolore elit magna',
					es_ES: 'cupidatat proident esse laborum in',
					fr_FR: 'velit Lorem minim aliqua eiusmod',
					ja_JP: 'deserunt id anim Lorem incididunt',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '48672ea7-f8bf-4c45-9e57-6248fdbb53ca',
			fieldType: 'textarea',
			content: {
				archived: false,
				fieldName: 'nostrud mollit',
				label: {
					en_US: 'dolor aliquip enim velit et',
					es_ES: 'ad dolore ex officia quis',
					fr_FR: 'incididunt enim cillum nostrud aliqua',
					ja_JP: 'magna et nostrud laborum nulla',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '2b55997a-8b19-48b4-929c-25293a45b3e6',
			fieldType: 'textinput',
			content: {
				archived: false,
				fieldName: 'nisi ad',
				label: {
					en_US: 'id cupidatat commodo veniam duis',
					es_ES: 'deserunt labore commodo eu in',
					fr_FR: 'ipsum et ad quis est',
					ja_JP: 'in reprehenderit labore sunt exercitation',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'd60d7990-4816-4552-855d-62dc3d571335',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'anim irure',
				label: {
					en_US: 'dolore occaecat aliqua voluptate ullamco',
					es_ES: 'nostrud exercitation nostrud tempor eu',
					fr_FR: 'deserunt consequat esse sit exercitation',
					ja_JP: 'esse deserunt consectetur sunt cillum',
				},
				choice: 'checkbox',
				choices: {
					en_US: [
						'in quis eu occaecat Lorem',
						'exercitation ex non amet veniam',
						'voluptate fugiat sunt veniam duis',
						'do ex duis ipsum fugiat',
					],
					es_ES: [
						'quis amet aute aliqua mollit',
						'exercitation proident sit laboris non',
						'culpa voluptate non nisi officia',
						'qui exercitation eiusmod ad et',
					],
					fr_FR: [
						'sint dolore adipisicing nostrud irure',
						'veniam minim fugiat anim enim',
						'duis sint in in adipisicing',
						'in dolor commodo id dolor',
					],
					ja_JP: [
						'voluptate tempor dolor tempor laboris',
						'ea consequat excepteur id do',
						'exercitation anim in non in',
						'qui esse voluptate minim do',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '3d10022b-e479-4f26-81b7-7df5748ae520',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'ea veniam',
				label: {
					en_US: 'velit ex aliquip ullamco in',
					es_ES: 'occaecat dolor labore mollit minim',
					fr_FR: 'officia in anim enim deserunt',
					ja_JP: 'in anim occaecat culpa ex',
				},
				choice: 'dropdown',
				choices: {
					en_US: [
						'excepteur in est ad sit',
						'Lorem elit laborum do qui',
						'velit esse sint proident aute',
						'pariatur consectetur cillum ex et',
					],
					es_ES: [
						'ipsum do ea aliqua mollit',
						'occaecat quis proident enim consectetur',
						'Lorem consequat duis id fugiat',
						'irure aute proident et laboris',
					],
					fr_FR: [
						'ex dolore Lorem labore aliqua',
						'quis eiusmod adipisicing exercitation nostrud',
						'ex duis sint consectetur occaecat',
						'elit amet veniam non laboris',
					],
					ja_JP: [
						'elit labore fugiat amet labore',
						'incididunt amet velit labore excepteur',
						'qui sunt ad est voluptate',
						'esse id mollit do reprehenderit',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'c701c03f-3258-4e86-86a9-44c3729372a3',
			fieldType: 'choice',
			content: {
				archived: false,
				fieldName: 'elit incididunt',
				label: {
					en_US: 'tempor minim magna est aliquip',
					es_ES: 'aute fugiat dolore proident ipsum',
					fr_FR: 'aliqua Lorem commodo consectetur incididunt',
					ja_JP: 'ea nostrud ipsum cillum irure',
				},
				choice: 'radio',
				choices: {
					en_US: [
						'commodo dolore id reprehenderit nulla',
						'anim laborum fugiat incididunt id',
						'ut sint ea id ullamco',
						'id dolor sit labore dolor',
					],
					es_ES: [
						'minim ullamco cillum sit fugiat',
						'nisi quis do cillum incididunt',
						'adipisicing elit id veniam reprehenderit',
						'reprehenderit et eu Lorem velit',
					],
					fr_FR: [
						'aliquip esse duis sint incididunt',
						'amet ut ullamco eiusmod qui',
						'dolore occaecat sint nostrud exercitation',
						'ex eu voluptate aute ex',
					],
					ja_JP: [
						'ullamco quis dolor ullamco sit',
						'voluptate nisi nisi pariatur sit',
						'pariatur aliquip et mollit aute',
						'duis consectetur voluptate incididunt fugiat',
					],
				},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 'a02ede02-0eea-4d0c-b49d-27c157981688',
			fieldType: 'paragraph',
			content: {
				archived: false,
				fieldName: 'adipisicing eiusmod',
				label: {
					en_US: 'do proident duis culpa Lorem',
					es_ES: 'minim consequat deserunt aliquip voluptate',
					fr_FR: 'aliqua laboris consequat consectetur veniam',
					ja_JP: 'adipisicing duis dolor dolore esse',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '21d66494-ff5a-4f94-8fa6-5b7acc4ad3fc',
			fieldType: 'textarea',
			content: {
				archived: false,
				fieldName: 'consectetur reprehenderit',
				label: {
					en_US: 'pariatur ea dolor nostrud esse',
					es_ES: 'aute magna elit ullamco voluptate',
					fr_FR: 'qui non consequat qui quis',
					ja_JP: 'dolor excepteur duis laboris officia',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '31c66494-ff5a-4f94-8fa6-5b7acc4ad3fe',
			fieldType: 'textarea',
			content: {
				archived: true,
				fieldName: 'dconsectetur reprehenderit',
				label: {
					en_US: 'dpariatur ea dolor nostrud esse',
					es_ES: 'daute magna elit ullamco voluptate',
					fr_FR: 'dqui non consequat qui quis',
					ja_JP: 'ddolor excepteur duis laboris officia',
				},
				choice: null,
				choices: {},
				defaultLanguage: 'en_US',
			},
		},
		{
			key: '31c6648484-ff5a-4f94-8fa6-5b7acc4ad3fe',
			fieldType: 'choice',
			content: {
				archived: true,
				fieldName: '"Hey New Question"',
				label: {
					en_US: 'dpariatur ea dolor nostrud esse',
				},
				choice: 'radio',
				choices: { en_US: ['1', '2'] },
				defaultLanguage: 'en_US',
			},
		},
		{
			key: 1124,
			fieldType: 'paragraph',
			content: {
				fieldName: 'Instructions',
				editorText: {
					blocks: [
						{
							key: '5ne1g',
							text: 'After completion of the interview, please rate the candidate on a scale of 1-5 (1 being Much Less Than Acceptable to 5 being Much More than Acceptable) on each of the below competencies. ',
							type: 'unstyled',
							depth: 0,
							inlineStyleRanges: [],
							entityRanges: [],
							data: {},
						},
					],
					entityMap: {},
				},
				label: {
					en_US: {},
				},
				validators: {
					required: false,
				},
			},
		},
		{
			key: 4606,
			fieldType: 'paragraph',
			content: {
				dependency: {
					show: true,
					when: {},
				},
				choices: {
					en_US: {},
				},
				fieldName: 'Directions',
				label: {
					en_US: {
						en_US:
							"Candidate evaluation forms are to be completed by the interviewer to determine the candidate's overall qualification for the position.  Under each heading the interviewer should give the candidate a numeric rating.  As a reminder, we will require you to reach a determination on whether to proceed with the candidate.  \n\nOn a scale from 1 to 5 please check the box that most reflects the interview.  1 = Does Not Meet Job Requirements; 2 - Somewhat Meets Job Requirements; 3 = Meet Job Requirements; 4 = Exceeds Job Requirements; and 5 = Substanntially Exceeds Job Requirements. ",
					},
				},
				choice: null,
				editorText: {
					blocks: [
						{
							key: 'a49p',
							text: "Candidate evaluation forms are to be completed by the interviewer to determine the candidate's overall qualification for the position.  Under each heading the interviewer should give the candidate a numeric rating.  As a reminder, we will require you to reach a determination on whether to proceed with the candidate.  ",
							type: 'unstyled',
							depth: 0,
							inlineStyleRanges: [
								{
									offset: 0,
									length: 317,
									style: 'color-rgb(51,51,51)',
								},
								{
									offset: 0,
									length: 317,
									style: 'bgcolor-rgb(255,255,255)',
								},
								{
									offset: 0,
									length: 317,
									style: 'fontsize-14',
								},
								{
									offset: 0,
									length: 317,
									style: 'fontfamily-Calibri',
								},
							],
							entityRanges: [],
							data: {},
						},
						{
							key: '8s4ih',
							text: 'On a scale from 1 to 5 please check the box that most reflects the interview.  1 = Does Not Meet Job Requirements; 2 - Somewhat Meets Job Requirements; 3 = Meet Job Requirements; 4 = Exceeds Job Requirements; and 5 = Substanntially Exceeds Job Requirements. ',
							type: 'unstyled',
							depth: 0,
							inlineStyleRanges: [
								{
									offset: 0,
									length: 257,
									style: 'color-rgb(51,51,51)',
								},
								{
									offset: 0,
									length: 257,
									style: 'bgcolor-rgb(255,255,255)',
								},
								{
									offset: 0,
									length: 257,
									style: 'fontsize-14',
								},
								{
									offset: 0,
									length: 257,
									style: 'fontfamily-Source Sans Pro", sans-serif',
								},
							],
							entityRanges: [],
							data: {},
						},
					],
					entityMap: {},
				},
				validators: {
					required: false,
				},
			},
		},
		{
			key: 'c701c03f-3258-4e86-86a9-44c3729372a324',
			fieldType: 'number',
			content: {
				archived: false,
				isRating: true,
				fieldName: 'Rating question',
				label: {
					en_US: 'How excited are you for rating questions?',
				},
				defaultLanguage: 'en_US',
			},
		},
	],
	page_size: 10,
};

export const question = {
	key: 'f4e17259-6cbc-4976-ac8b-2fcd556347be',
	fieldType: 'choice',
	content: {
		archived: false,
		fieldName: 'minim deserunt',
		label: {
			en_US: label,
			es_ES: 'reprehenderit voluptate mollit aute veniam',
			fr_FR: 'ad amet fugiat deserunt laboris',
			ja_JP: 'pariatur incididunt duis culpa irure',
		},
		choice: 'checkbox',
		choices: {
			en_US: [
				'do ut culpa voluptate proident',
				'nulla irure veniam excepteur officia',
				'adipisicing occaecat veniam elit veniam',
				'dolore labore irure irure ad',
			],
			es_ES: [
				'adipisicing fugiat voluptate sit quis',
				'enim do veniam nostrud ipsum',
				'reprehenderit dolore esse laboris ipsum',
				'commodo voluptate ea ipsum dolor',
			],
			fr_FR: [
				'velit officia magna amet veniam',
				'eu veniam consequat excepteur excepteur',
				'adipisicing commodo fugiat mollit in',
				'est est qui tempor adipisicing',
			],
			ja_JP: [
				labelJp,
				'anim incididunt ad quis eu',
				'ullamco consequat pariatur minim magna',
				'voluptate non aliqua qui mollit',
			],
		},
	},
};

export const recommendationGroup = {
	formName: {
		en_US: 'Overall Recommendations',
	},
	formId: 1,
	formItems: [
		{
			fieldType: 'number',
			content: {
				fieldName: 'Recommend for Hire',
				label: {
					en_US: 'Do you recommend for this position?',
				},
				validators: {
					required: true,
				},
			},
			key: 541,
		},
		{
			fieldType: 'number',
			content: {
				fieldName: 'Recommend for Other Positions',
				label: {
					en_US: 'Would you recommend for another position?',
				},
				validators: {
					required: false,
				},
			},
			key: 542,
		},
		{
			fieldType: 'textarea',
			content: {
				fieldName: 'Overall Thoughts',
				label: {
					en_US: 'What are your overall thoughts on the candidate?',
				},
				validators: {
					required: true,
				},
			},
			key: 543,
		},
	],
	versionId: 1,
	customerId: 1111111111,
	createdDate: '2025-01-14T16:17:33.925960Z',
	updatedDate: '2025-01-14T16:17:33.925960Z',
	defaultLanguage: 'en_US',
	attributes: {
		GROUP_TYPE: 'recommendations',
	},
};

export const form = {
	formName: {
		en_US: 'dolore ullamco occaecat ad Lorem',
		es_ES: 'proident tempor qui anim do',
		fr_FR: 'cupidatat eiusmod amet eiusmod ipsum',
		ja_JP: 'aliquip enim nostrud elit velit',
	},
	formId: 61,
	updatedDate: '2021-07-08T02:01:35.852Z',
	defaultLanguage: 'en_US',
	formItems: questions.items.map((q) => ({ ...q, required: true })),
	recommendations: recommendationGroup.formItems,
	instructions: '### Instructions',
};

export const createdForm = {
	id: 1000,
	version: 0,
	names: [
		{
			name: 'New Test Form2',
			locale: 'en_US',
			localizedText: 'New Test Form2',
		},
	],
	createdBy: 'biz-collab-feedback-service',
	createdDate: '2022-02-02T08:09:55.301Z',
	updatedDate: '2022-02-02T08:09:55.3Z',
	questions: [
		{
			questionId: 595,
			required: false,
		},
		{
			questionId: 596,
			required: false,
		},
		{
			questionId: 681,
			required: false,
		},
	],
};

export const associatedForms = [
	{
		formName: {
			en_US: label,
		},
		formId: '1',
		formItems: [],
		versionId: 9,
		customerId: 7706,
		createdDate: '2021-04-20T13:50:57.212Z',
		updatedDate: '2021-09-02T15:34:54.489Z',
	},
	{
		formName: {
			en_US: labelJp,
		},
		formId: '2',
		formItems: [],
		versionId: 0,
		customerId: 7706,
		createdDate: '2021-05-07T19:48:14.002Z',
		updatedDate: '2021-06-07T18:32:07.204Z',
	},
	{
		formName: {
			en_US: 'Asscociated Test Form-1',
		},
		formId: '3',
		formItems: [],
		versionId: 0,
		customerId: 7706,
		createdDate: '2022-02-02T07:43:09.92Z',
		updatedDate: '2022-02-02T07:43:09.92Z',
	},
	{
		formName: {
			en_US: 'Asscociated Test Form-2',
		},
		formId: '4',
		formItems: [],
		versionId: 0,
		customerId: 7706,
		createdDate: '2022-02-02T07:48:14.795Z',
		updatedDate: '2022-02-02T07:48:14.795Z',
	},
	{
		formName: {
			en_US: 'Asscociated Test Form-3',
		},
		formId: '5',
		formItems: [],
		versionId: 0,
		customerId: 7706,
		createdDate: '2022-02-02T08:09:55.301Z',
		updatedDate: '2022-02-02T08:09:55.3Z',
	},

	{
		formName: {
			en_US: 'Asscociated Test Form-4',
		},
		formId: '6',
		formItems: [],
		versionId: 0,
		customerId: 7706,
		createdDate: '2022-02-03T09:00:15.901Z',
		updatedDate: '2022-02-03T09:00:15.901Z',
	},

	{
		formName: {
			en_US: 'Associated form-5',
		},
		formId: '7',
		formItems: [],
		versionId: 0,
		customerId: 7706,
		createdDate: '2022-02-08T05:58:59.331Z',
		updatedDate: '2022-02-08T05:58:59.33Z',
	},
];

export const interviewTemplates = [
	'Virtual Interview Template',
	'In-Person Interview Template',
	'Technical Interview Template',
];
